import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing-report',
  templateUrl: './billing-report.component.html',
  styleUrls: ['./billing-report.component.scss']
})
export class BillingReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
